import invariant from 'ts-tiny-invariant';
export function isRecord(value) {
  return value !== null && (typeof value === 'object' || typeof value === 'function') && !Array.isArray(value);
}
export function assertIsRecord(value, message) {
  invariant(isRecord(value), message);
}